// src/modules/app-views/_apps/appsindico/unitProfiles/pages/Init/components/tableColumns/roomsColumn.jsx
// *******************************************************************************
// ROOMS COLUMN
// *******************************************************************************

import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function roomsColumn(buildColumnProps, options = {}) {
  const {
    key = 'rooms',
    title = 'rooms',
    dataIndex = 'rooms',
    width = 80,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: val => (val != null ? val : '-'),
  };
}

export default roomsColumn;
